
export const getVimeoThumbnail = async (videoID) => {


    const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${videoID}`
    );
    

    const json = await response.json();

    return json.thumbnail_url.split("_")[0] + "_720x405";
};

export const getVimeoVideoDetails = async (videoID) => {

    const response = await fetch(
        `https://vimeo.com/api/oembed.json?url=https://player.vimeo.com/video/${videoID}`
    );
    

    const json = await response.json();

    return json;
};